<section class="section section-components pb-0" id="section-components">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <!-- Basic elements -->
        <h2 class="mb-5">
          <span>Basic Elements</span>
        </h2>
        <!-- Buttons -->
        <h3 class="h4 text-success font-weight-bold mb-4">Buttons</h3>
        <!-- Button styles -->
        <div>
          <button class="btn btn-primary" type="button">Button</button>
          <button class="btn btn-icon btn-3 btn-primary" type="button">
            <span class="btn-inner--icon"><i class="ni ni-bag-17"></i></span>
            <span class="btn-inner--text">With icon</span>
          </button>
          <button class="btn btn-icon btn-2 btn-primary" type="button">
            <span class="btn-inner--icon"><i class="ni ni-bag-17"></i></span>
          </button>
          <!-- Button wizes -->
          <div class="mb-3 mt-5">
            <small class="text-uppercase font-weight-bold">Pick your size</small>
          </div>
          <button class="btn btn-sm btn-primary" type="button">Small</button>
          <button class="btn btn-1 btn-primary" type="button">Regular</button>
          <button class="btn btn-lg btn-primary" type="button">Large Button</button>
        </div>
        <!-- Button colors -->
        <div class="mb-3 mt-5">
          <small class="text-uppercase font-weight-bold">Pick your color</small>
        </div>
        <button class="btn btn-1 btn-primary" type="button">Primary</button>
        <button class="btn btn-1 btn-info" type="button">Info</button>
        <button class="btn btn-1 btn-success" type="button">Success</button>
        <button class="btn btn-1 btn-warning" type="button">Warning</button>
        <button class="btn btn-1 btn-danger" type="button">Danger</button>
        <button class="btn btn-1 btn-neutral" type="button">Neutral</button>
        <div class="mb-3 mt-5">
          <small class="text-uppercase font-weight-bold">Outline</small>
        </div>
        <button class="btn btn-1 btn-outline-primary" type="button">Outline-primary</button>
        <button class="btn btn-1 btn-outline-info" type="button">Outline-info</button>
        <button class="btn btn-1 btn-outline-success" type="button">Outline-success</button>
        <button class="btn btn-1 btn-outline-warning" type="button">Outline-warning</button>
        <button class="btn btn-1 btn-outline-danger" type="button">Outline-danger</button>
        <!-- Button links -->
        <div class="mb-3 mt-5">
          <small class="text-uppercase font-weight-bold">Links</small>
        </div>
        <a href="javascript:void(0)" class="btn btn-link text-default">Default</a>
        <a href="javascript:void(0)" class="btn btn-link text-primary">Primary</a>
        <a href="javascript:void(0)" class="btn btn-link text-info">Info</a>
        <a href="javascript:void(0)" class="btn btn-link text-success">Success</a>
        <a href="javascript:void(0)" class="btn btn-link text-warning">Warning</a>
        <a href="javascript:void(0)" class="btn btn-link text-danger">Danger</a>
      </div>
    </div>
  </div>
</section>
